import { createContext, useContext } from 'react'

export type BreadcrumbExtra = { label: string; href?: string } | null

export const BreadcrumbContext = createContext<{
  extra: BreadcrumbExtra
  setExtra: (v: BreadcrumbExtra) => void
}>({ extra: null, setExtra: () => {} })

export function useBreadcrumb() {
  return useContext(BreadcrumbContext)
}
